import fetch from "../../auth/FetchInterceptor";

export const createService = function (data) {
  return fetch({
    url: '/services',
    method: 'post',
    data
  })
}

export const updateService = function (id, data) {
  return fetch({
    url: `/services/${id}`,
    method: 'put',
    data
  })
}

export const getService = function (id) {
  return fetch({
    url: `/services/${id}`,
    method: 'get'
  })
}

export const deleteService = function (id) {
  return fetch({
    url: `/services/${id}`,
    method: 'delete'
  })
}